<template>
<div class="chapter">
<div class="inner_page">
<p class="cn" id="ch5">5</p>
<p class="co">A rabbit skin – once you have made a quick cut up and down the hind legs and another around the head – slips off like a glove, and can be stretched on a frame and tanned and sold for a shilling to the rabbit-oh. The beak of a parrot is only worth sixpence and they’re as hard as hell to saw off. A fox’s pelt brings four shillings. And if I was lucky enough to trap a dingo, the scalp was worth a whole pound. The rabbit-oh paid the money into Mr Toad’s moist hand, even though I was the one who trapped the rabbits and skinned them and tanned their soft little hides, and Mr Toad put the money inside his trousers and afterwards hid it somewhere.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter5.vue?1d9e3dcd